module.exports = __webpack_public_path__ + "img/17_94.896f7dd6.png";